export default __webpack_public_path__ + "static/media/139.598eb1a4.png";